// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__em3R4","content":"Consent_content__1RfFV","footer":"Consent_footer__VcP-1"};